import React, {useContext, useEffect, useState, useRef} from "react";
import TableAntD from "@common/TableAntD";
import PopConfirm from "@common/PopConfirm";
import createTableAntDHeaderFilter from "@common/TableAntDHeaderFilterColumn";
import axios from "@common/axios";
import {BrandContext} from "@context/BrandContext";
import {getSittingsText} from "./StudentTestAssignments";
import {UserContext} from "@context/UserContext";
import Button from "@common/Button";
import CircularLoader from "@common/CircularLoader";
import {Tag} from "antd";
import dayjs from "dayjs";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {isCancel} from "axios";

const handleCloseTestAssignment = (record)=>{
    submitTest(record.testAssignmentId);
}
const handleStartManualTestAssignment = (record)=>{
    startManualMarkedTest(record.testAssignmentId, record.testId, record.testAssignmentStatus);
}

const TEST_TYPE_ARR = [
    {text: 'Exam', value: 'Exam'},
    {text: 'Test', value: 'Test'},
    {text: 'Diagnostic', value: 'Diagnostic'}
];

const OpenTestAssignments = (props) =>{
    const {title = '', defaultTablePageSize = 6} = props;
    const
        brandConfig = useContext(BrandContext),
        {user} = useContext(UserContext),
        {loadShortcutByUrl} = useCurrentShortcut(),
        [addStyle, setAddStyle] = useState(false);

    const handleStartTestAssignment = (testAssignmentId, diagnosticTest, adaptive)=> {
        if(testAssignmentId === undefined || diagnosticTest === undefined) {
            return;
        }

        if(diagnosticTest == true) {
            if(adaptive) {
                //loadShortcutByUrl('/controlCentre/startAdaptiveTest.action', {testAssignmentId: testAssignmentId});
                loadShortcutByUrl('/web/ui/view/diagnosticStudentTest', undefined, testAssignmentId);
            } else {
                loadShortcutByUrl('/web/ui/view/diagnosticStudentTest', undefined, testAssignmentId);
            }
        } else {
            loadShortcutByUrl('/web/ui/view/studentTest', undefined, testAssignmentId);
            //loadShortcutByUrl('/controlCentre/startTest.action', {testAssignmentId: testAssignmentId});
        }
    }

    const open_cols = {
        name:{title:'Name', key:'name', dataIndex:'name', width:'40%',
            sorter: (a,b)=>{
                return a.testName.localeCompare(b.testName);
            },
            sortDirections: ['ascend', 'descend'],
        },
        type: createTableAntDHeaderFilter('Type', 'type', 'type', TEST_TYPE_ARR, 'type'),
        assigned:{title:'Assigned', key:'assigned', dataIndex:'assigned',
            sorter: (a,b)=>{
                return a.assignedDate - b.assignedDate;
            },
            width: 50,
            sortDirections: ['ascend', 'descend']},
        teacher:{title:'Teacher', key:'teacher', dataIndex:'teacher'},
        test:{title:'Test', key:'test', dataIndex:'test',
            render: (_, record) => {
                return (<>
                    {!record.autoMark &&
                        <div className={'flexColumn flexCentre smallGap'}>
                            <Button onClick={()=>{handleStartManualTestAssignment(record)}}>PDF</Button>
                            {record.testAssignmentStatus === 'STARTED' &&
                                <Button onClick={()=>{handleCloseTestAssignment(record)}}>Close</Button>
                            }
                        </div>
                    }
                    {record.autoMark &&
                        <div className={'flexCentre'}>
                            {record.revision ?
                                <Button onClick={() => handleStartTestAssignment(record.testAssignmentId, record.diagnosticTest, record.adaptive)}
                                        aria-label={(record.testAssignmentStatus === 'STARTED' ? 'Resume ' : 'Start ') + brandConfig.testName.toLowerCase() + ' ' + record.testName}>
                                    {record.testAssignmentStatus === 'STARTED' ? 'Resume' : 'Start'}
                                </Button> :
                                <PopConfirm
                                    title={<span>You only get one attempt to answer all questions.<br/>Are you sure you want to start this {brandConfig.testName}?</span>}
                                    placement={'left'}
                                    cancelText={'Cancel'}
                                    okText={'Start ' + brandConfig.testName}
                                    onConfirm={() => handleStartTestAssignment(record.testAssignmentId, record.diagnosticTest, record.adaptive)}
                                >
                                    <Button aria-label={(record.testAssignmentStatus === 'STARTED' ? 'Resume ' : 'Start ') + brandConfig.testName.toLowerCase() + ' ' + record.testName}>
                                        {record.testAssignmentStatus === 'STARTED' ? 'Resume' : 'Start'}
                                    </Button>
                                </PopConfirm>
                            }
                        </div>
                    }
                </>)
            }}
    }, columnData = Object.values(open_cols);

    const modifyDataForTable = (rawData)=> {
        return rawData.map((row)=> {

            const oneWeekUntilExpiry =
                dayjs(row.endDate) > dayjs() &&
                dayjs(row.endDate) < dayjs().add(1,'week');

            return {
                key: row.testAssignmentId,
                ...row,
                [open_cols.name.key]: <div><p>{row.testName} <Tag className="ch-tag-secondary">{getSittingsText(row, brandConfig.assessmentTestName, brandConfig.revisionTestName)}</Tag></p>{row.note &&
                    <p className="ch-text-note">{row.note}</p>}{!row.isNoExpiry && <p className={oneWeekUntilExpiry?"ch-dashboard-warning-text":""}>{row.expiry}</p>}</div>,
                [open_cols.type.key]: row.testTypeDescription,
                [open_cols.assigned.key]: user.dateFormat.format((row.dateAssigned)) + ' '+ user.timeFormat.format((row.dateAssigned)),
                [open_cols.teacher.key]: (row.assignerTitle ? row.assignerTitle : '') + ' ' + row.assignerLastName,
                // [open_cols.test.key]: row.testName
            }
        })
    }

    const searchOpenTestAssignments = (params, handleTableData, handlePagingData, abortController)=>{
        axios.get('/web/ui/test/openStudentTestAssignments',{params:params, signal:abortController.signal})
            .then(response => {
                if (response && response.data) {
                    const responseData = modifyDataForTable(response.data.currPageContents);
                    handleTableData([...responseData.sort((a,b)=>{return a.endDate-b.endDate})]);
                    const {currPage, pageSize, totalResults} = response.data;
                    handlePagingData({currPage, pageSize, totalResults});
                    setAddStyle(totalResults > pageSize);
                }
            }).catch((error) => {
            //throws error if not purposefully cancelled
            if (!isCancel(error)) {
                console.error('Error loading student test assignments: ', error);
                displayToastMessage('', 'Error loading test assignments.', 'error', null,10000);
                throw error;
            }
        }).finally(()=>{
            abortController = null;
        });
    }


    return (
        <>
            {title && <h2 className={'padding--m'}>{title}</h2>}
            <TableAntD
                pagingDependencies={[]}
                rowKey="testAssignmentId"
                pagingData={{fetchFunction:searchOpenTestAssignments, params:{pageSize:defaultTablePageSize, currentPage:1}}}
                noDataMessage={<p className={'padding--m flexJustifyStart'}>{'No ' + brandConfig.assessmentTestName + 's currently assigned.'}</p>}
                columnData={columnData}
                dynamicWidth={true}
            />
        </>
    )
}
export default OpenTestAssignments;